import { load } from 'cheerio';

/**
 * Extracts description HTML for KBS provider by concatenating column_ elements.
 */
export function extractKBSPageDescription(htmlSource: string): string {
    const $ = load(htmlSource);
    let descriptionHtml = '';

    const columnDivs = $('[id^="column_"]');
    columnDivs.each((_, el) => {
        const content = $(el).html();
        if (content) {
            descriptionHtml += content;
        }
    });

    return descriptionHtml;
}
